/**
 *
 * Hero Carousel
 *
 * Initialize and define behavior of the block slider
 * Uses the Slick Slides jQuery plugin --> http://kenwheeler.github.io/slick/
 */

 const $         = require( 'jQuery' );
 const _model    = require( '../utilities/_model.js' );
 const throttled = require( '../_debounce.js' );
 
 var HeroCarousel = function(el){
 
   this.$el            = $(el);
   this.globalDefaults = {
     slidesToScroll  : 1,
     autoplaySpeed   : 5000,
     pauseOnDotsHover: true,
     dots            : true,
     arrows          : true,
     pauseOnHover    : true,
     responsive: [
        {
            breakpoint: 600,
            settings: {
                arrows      : false,
            }
        },
     ]
   };
 
   this.init();
 };
 
 HeroCarousel.prototype.init = function(){
   var data = this.$el.attr('data-slick'),
     options =  ! _model.empty( data ) ? JSON.parse( data ) : {},
     that = this,
     slickResize;
 
   //Init the slider
   options = $.extend( this.globalDefaults, options );
 
   // IMPORTANT:
   // There is hardly some documentation online to the init and reInit callbacks.
   // These have to come before the initialization of slick.
   // Because the slides are scaled relative to the window dimensions, the static slick responsive options don't work
   // One needs to recalculate the scroll steps based on the actual visible slides.
   // This is done on init, reInit and resize / orientationchange of the screen.
   // But keep the initial options because the initialize Slick so that these values can be read.
   this.$el.on('init', function (event, slick) {
 
     let $slickEl = slick.$slider;
 
     if( $slickEl.length && $slickEl.is(':visible') ){
       that.recalculateVisibleSlideCount(slick);
       that.onAllImagesLoaded(function () { that.makeAllSlidesTallAsTheTallestOne(); })
     }
 
 
   });
 
   this.$el.on('reInit', function (event, slick) {
 
     let $slickEl = slick.$slider;
 
     if( $slickEl.length && $slickEl.is(':visible') ){
       that.recalculateVisibleSlideCount(slick);
       that.makeAllSlidesTallAsTheTallestOne();
     }
 
 
   });
 
   this.carousel = this.$el.slick( options );
 
   this.carousel.on('beforeChange', function(event, slick, currentSlide, nextSlide){
     that.$el.find('.slick-slide').removeClass('itbl-has-past');
     that.$el.find('.slick-slide[data-slick-index="'+nextSlide+'"]').prevAll().addClass('itbl-has-past');
   });
 
   $(document).one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function(){
     that.carousel.slick('setPosition');
   });
 
   $(window).on('resize orientationchange', throttled( 250, function(){
 
     var slick = $(that.carousel)[0].slick;
     slick.refresh();
 
     if( slick.$slider.is(':visible') ){
 
       that.recalculateVisibleSlideCount(slick);
       that.makeAllSlidesTallAsTheTallestOne();
 
     }
 
   } ));
 
 };
 
 /**
  * Method recalculates the slick scrolled and shown slides. Pay attention.
  * It can have a responsive option with separate settings for separate screen sizes.
  *
  * @param slick - Slick instance
  */
 HeroCarousel.prototype.recalculateVisibleSlideCount = function (slick) {
   var sliderWidth = this.$el.width();
   var slideWidth = this.$el.find('.slick-slide').width();
   slideWidth = slideWidth == null ? sliderWidth : slideWidth;
   var visibleSlideCount = Math.floor( sliderWidth / slideWidth);
 
   var responsive = slick.slickGetOption('responsive');
   if (responsive) {
     for (var i = 0; i < responsive.length; i++) {
       var x = responsive[i];
 
       if (x.hasOwnProperty('settings')) {
         var settings = x.settings;
 
         if (settings.hasOwnProperty('slidesToShow')) {
           settings.slidesToShow = visibleSlideCount;
         }
 
         if (settings.hasOwnProperty('slidesToScroll')) {
           settings.slidesToScroll = 2;
         }
       }
     }
 
     slick.slickSetOption('slidesToScroll', visibleSlideCount);
     slick.slickSetOption('slidesToShow', visibleSlideCount);
     slick.refresh();
   }
 };
 
 // Hack inbound:
 // Make the height of all slides same as the height of the tallest one
 // We need the container height so that we can use height: 100% for the slick-slide, otherwise it doesn't work.
 HeroCarousel.prototype.makeAllSlidesTallAsTheTallestOne = function () {
   this.$el.find('.slick-track').css({
     height: this.$el.find('.slick-track')[0].getBoundingClientRect().height + 'px',
   });
 };
 
 HeroCarousel.prototype.onAllImagesLoaded = function (cb) {
   var $images = this.$el.find('img');
   var leftToLoad = $images.length;
 
   var onImageVisible = function () {
     leftToLoad--;
     if (leftToLoad === 0 && cb) cb();
   };
 
   if (leftToLoad === 0) {
     onImageVisible();
     return;
   }
 
   $images.on('load', onImageVisible).each(function() { if(this.complete) $(this).load(); });
   $images.on('error', onImageVisible);
 };
 
 $(document).ready(function(){
   $('.js-itbl-hero-carousel').each(function(){
     new HeroCarousel( this );
   });
 
 });
 
 // Initialize dynamic block preview (editor).
 if( window.acf ) {
   //addAction for Hero Carousel
   window.acf.addAction( 'render_block_preview/type=hero-carousel', function( el, props ){
 
     $(el).find('.js-itbl-hero-carousel').each(function(){
       new HeroCarousel( this );
     });
   } );
   
 }
 